var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E4E2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78 4.42C9.78 4.67333 9.64667 4.89333 9.38 5.08C9.11333 5.26 8.81 5.35 8.47 5.35C8.13 5.35 7.86 5.28333 7.66 5.15C7.46667 5.01667 7.37 4.83667 7.37 4.61C7.37 4.30333 7.51333 4.06333 7.8 3.89C8.08667 3.71667 8.39 3.63 8.71 3.63C9.03 3.63 9.28667 3.69667 9.48 3.83C9.68 3.96333 9.78 4.16 9.78 4.42ZM7.83 12.25C7.41667 12.25 7.11667 12.1467 6.93 11.94C6.74333 11.7333 6.65 11.42 6.65 11C6.65 10.5733 6.86333 9.43667 7.29 7.59L6.73 6.75C7.56333 6.25 8.22 6 8.7 6C8.97333 6 9.16667 6.06 9.28 6.18C9.39333 6.29333 9.45 6.48 9.45 6.74C9.45 6.84 9.32667 7.42667 9.08 8.5C8.83333 9.57333 8.71 10.34 8.71 10.8C8.71 11.26 8.81333 11.58 9.02 11.76C8.64667 12.0867 8.25 12.25 7.83 12.25Z",
    fill: "#4D4F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i_icon.c9c08b1b2f34dae27a0002a81ca02732.svg";
export { ForwardRef as ReactComponent };